const isInMobileWebview = () => {
    var standalone = (window.navigator as any).standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);
  
    if (ios) {
      return !standalone && !safari;
    } else {
      return userAgent.includes('wv');
    }
  };
  
  const isInIframe = () => {
      try {
          return window.self !== window.top;
      } catch (e) {
          return true;
      }
  }
  
  export const isInTeams = () => {
      return isInMobileWebview()||isInIframe();
  }
